import { alpha } from '@mui/material/styles';

import { BackgroundId } from './catalog';

/** CSS behind the transparent canvas. Every scene has a day and a night variant. */
export const backgroundCss = (
    id: BackgroundId,
    color: string,
    dark: boolean
): string => {
    const glow = `radial-gradient(circle at 50% 38%, ${alpha(color, dark ? 0.35 : 0.3)} 0%, ${alpha(color, 0.08)} 36%, transparent 62%)`;
    switch (id) {
        case 'beach':
            return dark
                ? [
                      glow,
                      'radial-gradient(circle at 80% 18%, #fff6d0 0 3%, transparent 3.5%)',
                      'linear-gradient(to bottom, #12204a 0%, #2c3e7a 50%, #1b3a5c 50%, #1d4f73 62%, #6b5a45 62%, #4d4030 100%)',
                  ].join(',')
                : [
                      glow,
                      'radial-gradient(circle at 82% 16%, #fff7b8 0 4%, rgba(255,230,120,.5) 6%, transparent 9%)',
                      'linear-gradient(to bottom, #7cc8ff 0%, #cdeeff 50%, #4fb3d9 50%, #7fd1e8 62%, #f6e2a8 62%, #efc97a 100%)',
                  ].join(',');
        case 'space':
            return [
                glow,
                'radial-gradient(circle at 18% 72%, #6a5acd 0 5%, #3b2f8f 7%, transparent 7.5%)',
                'radial-gradient(1.5px 1.5px at 20px 30px, #fff, transparent)',
                'radial-gradient(1px 1px at 90px 80px, #cfd8ff, transparent)',
                'radial-gradient(2px 2px at 150px 20px, #fff, transparent)',
                'radial-gradient(1px 1px at 60px 140px, #fff, transparent)',
                'radial-gradient(circle at 50% 40%, #1b1450 0%, #0a0824 70%, #05040f 100%)',
            ].join(',');
        case 'farm':
            return dark
                ? [
                      glow,
                      'radial-gradient(circle at 15% 15%, #fff6d0 0 2.5%, transparent 3%)',
                      'radial-gradient(ellipse 70% 30% at 25% 70%, #2d5a34 0 98%, transparent 100%)',
                      'radial-gradient(ellipse 80% 28% at 80% 74%, #265030 0 98%, transparent 100%)',
                      'linear-gradient(to bottom, #101c3d 0%, #26386b 62%, #1f4a2c 62%, #173a22 100%)',
                  ].join(',')
                : [
                      glow,
                      'radial-gradient(circle at 15% 14%, #fff7b8 0 3.5%, rgba(255,230,120,.5) 5.5%, transparent 8%)',
                      'radial-gradient(ellipse 70% 30% at 25% 70%, #7cc65a 0 98%, transparent 100%)',
                      'radial-gradient(ellipse 80% 28% at 80% 74%, #66b84a 0 98%, transparent 100%)',
                      'linear-gradient(to bottom, #8fd3ff 0%, #def3ff 62%, #5fae3f 62%, #4a9532 100%)',
                  ].join(',');
        default:
            return glow;
    }
};

/** Whether the scene behind the timer is dark, so the clock must be light. Space is dark in both modes. */
export const isDarkScene = (id: BackgroundId, dark: boolean): boolean =>
    dark || id === 'space';

/** The star tiles of the space scene need an explicit repeat size. */
export const backgroundSize = (id: BackgroundId): string | undefined =>
    id === 'space'
        ? 'auto, auto, 180px 180px, 180px 180px, 180px 180px, 180px 180px, auto'
        : undefined;
